<div class="home-container">
    <div class="home">
        <div class="image-container">
            <img src="./assets/images/logo.png" />
        </div>
        <div class="title"><h1>ADMIN FELÜLET</h1></div>
    </div>
</div>
